import * as React from "react";
const SvgFiRrVolumeMute = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-volume-mute_svg__a)">
      <path
        fill="#062147"
        d="M13.644.418a1 1 0 0 0-.821-.215c-3 .555-5.754 2.302-7.554 4.794h-.271a5.007 5.007 0 0 0-5 5v4.006c0 2.757 2.243 5 5 5h.271c1.802 2.495 4.555 4.243 7.554 4.794q.09.016.181.017a1.001 1.001 0 0 0 1-1V1.187a1 1 0 0 0-.36-.77m-1.64 21.117a10.14 10.14 0 0 1-5.113-3.703l-.299-.415a1 1 0 0 0-.811-.415h-.782c-1.654 0-3-1.346-3-3V9.997c0-1.654 1.346-3 3-3h.782a1 1 0 0 0 .811-.415l.3-.415a10.15 10.15 0 0 1 5.113-3.702v19.068zm11.729-7.242a.999.999 0 1 1-1.414 1.414l-2.293-2.293-2.293 2.293a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414L18.612 12l-2.293-2.293a.999.999 0 1 1 1.414-1.414l2.293 2.293 2.293-2.293a.999.999 0 1 1 1.414 1.414L21.44 12z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-volume-mute_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrVolumeMute;
